import { lazy, Suspense } from "react"
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { type RootState } from "../../store";
import AppLayout from "../layouts/AppLayout";
import AuthGate from "./AuthGate";
import RouteFallback from "../ui/RouteFallback";
// import NotFound from '../Routes/NotFound';
import Login from '../../Routes/Login';

const Dashboard = lazy(() => import('../../Routes/Dashboard'));
const Payment = lazy(() => import('../../Routes/Payment'));


const AppRoutes = () => {
    // const [searchParams, setSearchParams] = useSearchParams();
    const searchParams = new URLSearchParams(window.location.search);

    const currentOrderId = useSelector((state: RootState) => state.stepManagement.currentOrderId);
    const orderId = searchParams.get('orderId') || currentOrderId;

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <Suspense fallback={<RouteFallback />}>
                        <AuthGate>
                            <AppLayout>
                                <Dashboard />
                            </AppLayout>
                        </AuthGate>
                    </Suspense>
                }
            />
            <Route
                path="/payment"
                element={
                    <Suspense fallback={<RouteFallback />}>
                        {orderId ? (
                            <AuthGate>
                                <AppLayout>
                                    <Payment />
                                </AppLayout>
                            </AuthGate>
                        ) : (
                            <Navigate to="/" />
                        )}
                    </Suspense>
                }
            />
            <Route
                path="/login"
                element={
                    <Login />
                }
            />
            {/* <Route
                path="/404"
                element={
                    <NotFound />
                }
            /> */}
            {/* <Route path="*" element={<Navigate to="/404" />} /> */}

            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    )
}

export default AppRoutes;
